import React, { useState } from "react";
import { getImg } from "../../assets/getImg";
import "./index.css";

export default function Bottom(props) {
  return (
    <div className="zhyl_ckd_bottom">
      <div className="zhyl_ckd_bottom_txt_wrap">
        <span className="zhyl_ckd_bottom_txt1">
          ©2018 CK-NET All Rights Reseverd.
        </span>
        <a
          target="_blank"
          className="zhyl_ckd_bottom_txt2"
          href="https://beian.miit.gov.cn"
        >
          浙ICP备18026483号-2
        </a>
      </div>
    </div>
  );
}
